import navbar from "./navbar";
import layout from "./layout";
import auth from "./authentication";

import app from "./app";
import dashboard from "./dashboard";
import product from "./product";
import productsClient from "./productClients";
import productsRelatory from "./productsRelatory";
import invoice from "./invoice";
import repricing from "./repricing";
import oportunidade from "./oportunidade";
import cest from "./cest";
import ncm from "./ncm";
import stores from "./stores";
import upload from "./Upload";
import users from "./users";
import accessGroups from "./accessGroups";
import dialogAlert from "./DialogAlert/dialog";
import alertness from "./alertness";
import storeStatus from "./Stores/status";
import taxAnalises from "./taxAnalises";
import taxAnalysisProductsFilter from "./TaxAnalysis/productsSearch";
import internoListaClientes from "./Interno/listaClientes";
import storesForms from "./Stores/storesForms";
import fiscalDiagnosisProject from "./FiscalDiagnosis/project";
import diagnosticoDashboard from "./FiscalDiagnosis/dashboard";
import relatorioSkus from "./relatorioSkus";
import productsABC from "./productsABC";
import icmsNcm from "./icmsNcm";
import relatorioCfopCsts from "./relatorioCfop";
import relatorioDocumentosFiscais from "./Relatorio/documentosFiscais";
import countFilesCnpjs from "./countFiles";
import cnpjTotals from "./cnpjTotals";
import politicPrice from "./politicScreen";
import classificar from "./classificar";
import speds from "./speds";
import appEscrituracao from "./EscrituracaoFiscal/appEscrituracao";
import escrituracaoFiscalList from "./EscrituracaoFiscal/list";
import escrituracaoAssociation from "./EscrituracaoFiscal/association";
import escrituracaoAssociationNotesPendentes from "./EscrituracaoFiscal/association-notas-pendentes";
import parameterConfigurator from "./EscrituracaoFiscal/parameterConfigurator";
import escriturationClassification from "./EscrituracaoFiscal/classification";
import modules from "./modules";
import tagsXmls from "./tagsXmls";
import marketplace from "./Marketplace/marketplace";
import robot from "./Suporte/Robot/robot";
import resend from "./reenvios";
import actionsNotes from "./EscrituracaoFiscal/actionsNote";
import atualizacoes from "./atualizacoes";
import produtoEanGtin from "./productEanGtin";
import painelCmf from "./Suporte/Painel/painel";
import metas from "./metas";
import contractCategory from "./Contract/category";
import reportsEscrituration from "./EscrituracaoFiscal/reports";
import escrituracaoDash from "./EscrituracaoFiscal/escrituracaoDash";
import heatMap from "./heatMap";
import portaria from "./Legislacao/portaria";
import notificationAll from "./Configs/notifications";
import contratos from "./contratos";

import formContratos from "./Contratos/formContrato";
import icms from "./icms";
import classificacaoDireta from "./classificacaoDireta";
import boxAndRisk from "./boxAndRisk";
import queimaRiscoCategorias from "./showDoCliente/queimaRiscoCategorias";
import percentualEscrituracao from "./EscrituracaoFiscal/percentual";
import productReportsInvoices from "./Relatorio/productReportsInvoices";
import relatorioProdutosNovo from "./Relatorio/relatorioProdutosNovo";
import cbenef from "./Legislacao/cbenef";
import regrasTributarias from "./Legislacao/regrasTributarias";
import categoria from "./Legislacao/categoria";
import casosEspeciais from "./Legislacao/casosEspeciais";
import invoiceReceipt from "./EscrituracaoFiscal/invoiceReceipt";
import listaFinanceira from "./Financas/listaFinanceira";
import produtosImpactados from "./Legislacao/produtosImpactados";
import reverdescricao from "./reverDescricao";
import classificacaoIcms from "./Legislacao/classificacaoIcms";
import especificacoes from "./Legislacao/especificacoes";
import checklist from "./checklist";
import espValores from "./Legislacao/espValores";
import produtos from "./Legislacao/produtos";
import grupoEspecificacoes from "./Legislacao/grupoEspecificacoes";
import generalAnalytics from "./FiscalDiagnosis/generalAnalytics";
import legisCest from "./Legislacao/cest";
import notifications from "./notifications";
import legisDash from "./Legislacao/dash";
import classificacaoFiscal from "./classificacaoFiscal";
import taxLogs from "./taxLogs";
import relatorioProdutos from "./relatorioProdutos";
import painelMachine from "./painelMachine";
import systemConfigs from "./systemConfigs";
import clauseFilter from "./clauseFilter";
import questoesChecklist from "./Legislacao/questoesChecklist";
import calculadora from "./Calculadora";
import modificadores from "./Legislacao/modificadores";

const rootReducer = {
  auth,
  cest,
  users,
  navbar,
  layout,
  app,
  dashboard,
  product,
  productsClient,
  invoice,
  repricing,
  oportunidade,
  upload,
  users,
  ncm,
  accessGroups,
  stores,
  dialogAlert,
  alertness,
  storeStatus,
  productsRelatory,
  taxAnalises,
  taxAnalysisProductsFilter,
  internoListaClientes,
  storesForms,
  fiscalDiagnosisProject,
  diagnosticoDashboard,
  relatorioSkus,
  productsABC,
  icmsNcm,
  relatorioCfopCsts,
  relatorioDocumentosFiscais,
  countFilesCnpjs,
  cnpjTotals,
  politicPrice,
  classificar,
  speds,
  escrituracaoFiscalList,
  escrituracaoAssociation,
  appEscrituracao,
  escrituracaoAssociationNotesPendentes,
  parameterConfigurator,
  escriturationClassification,
  modules,
  tagsXmls,
  marketplace,
  robot,
  resend,
  actionsNotes,
  atualizacoes,
  produtoEanGtin,
  painelCmf,
  metas,
  contractCategory,
  reportsEscrituration,
  escrituracaoDash,
  heatMap,
  portaria,
  notificationAll,
  contratos,
  formContratos,
  regrasTributarias,
  icms,
  classificacaoDireta,
  boxAndRisk,
  queimaRiscoCategorias,
  percentualEscrituracao,
  productReportsInvoices,
  relatorioProdutosNovo,
  cbenef,
  categoria,
  casosEspeciais,
  invoiceReceipt,
  listaFinanceira,
  produtosImpactados,
  reverdescricao,
  notifications,
  legisDash,
  classificacaoFiscal,
  taxLogs,
  classificacaoIcms,
  especificacoes,
  checklist,
  espValores,
  relatorioProdutos,
  produtos,
  grupoEspecificacoes,
  generalAnalytics,
  legisCest,
  painelMachine,
  systemConfigs,
  clauseFilter,
  questoesChecklist,
  calculadora,
  modificadores,
};

export default rootReducer;
